import React, { useEffect, useState } from 'react';
import { DentosHeader } from '../components/DentosHeader';
import { DentosFooter } from '../components/DentosFooter';
import { ArrowRight, ExternalLink, ArrowUp } from 'lucide-react';
interface ToolsPageProps {
  onNavigate: (page: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo') => void;
}
const tools = [{
  id: 1,
  icon: '🔍',
  category: 'Калькуляторы',
  title: 'Скрытые потери клиники',
  description: 'Три утечки денег которые есть в каждой стоматологии. Незаписанные звонки, no-show, отток — всё в одном расчёте.',
  link: 'https://claude.ai/public/artifacts/f8faeabf-a1db-4feb-9f17-02683fd39033'
}, {
  id: 2,
  icon: '🪑',
  category: 'Калькуляторы',
  title: 'Юнит-экономика кресла',
  description: 'Реальная маржа и точка безубыточности по каждому рабочему месту. Поймите какое кресло зарабатывает а какое в минусе.',
  link: 'https://claude.ai/public/artifacts/1b6a4957-265e-4774-ac80-9bfe30f5b9b9'
}, {
  id: 3,
  icon: '💎',
  category: 'Калькуляторы',
  title: 'LTV калькулятор',
  description: 'Средний чек — метрика врача. LTV — метрика владельца. Реальная ценность пациента и всей семьи на 5-10 лет.',
  link: 'https://claude.ai/public/artifacts/ff36239b-6a92-44fc-b753-1cd51390ffb9'
}, {
  id: 4,
  icon: '⚙️',
  category: 'Калькуляторы',
  title: 'Окупаемость оборудования',
  description: 'Томограф, лазер, имплантологический набор — когда они начнут приносить прибыль? Готовые пресеты для популярного оборудования.',
  link: 'https://claude.ai/public/artifacts/4422260a-8620-4af9-a53b-de8865c66497'
}, {
  id: 5,
  icon: '📞',
  category: 'Калькуляторы',
  title: 'Стоимость слабого администратора',
  description: 'Разница между конверсией 40% и 70% — это не проценты. Посчитайте сколько денег теряете из-за одного навыка.',
  link: 'https://claude.ai/public/artifacts/bd840645-dc8a-46fc-8324-149a08d6fe2c'
}, {
  id: 6,
  icon: '📊',
  category: 'Калькуляторы',
  title: 'Точка безубыточности',
  description: 'Сколько пациентов нужно в месяц чтобы не работать в убыток — и сколько для реальной прибыли 20%.',
  link: 'https://claude.ai/public/artifacts/c52cffa4-5452-4924-9d8c-20cd6c118d38'
}, {
  id: 7,
  icon: '📈',
  category: 'Калькуляторы',
  title: 'ROI маркетинга',
  description: 'Сравните стоимость привлечения пациента по каждому каналу с его LTV. Найдите куда вкладывать бюджет а куда нет.',
  link: 'https://claude.ai/public/artifacts/ff90adce-3ef2-49e2-9290-fc41eb89646f'
}, {
  id: 8,
  icon: '🏥',
  category: 'Диагностика',
  title: 'Здоровье бизнеса',
  description: '20 вопросов. 5 зон: финансы, управление, маркетинг, персонал, операционка. Полный разбор с рекомендациями.',
  link: 'https://claude.ai/public/artifacts/715deaef-2500-441c-a556-a82cccd5a7ec'
}, {
  id: 9,
  icon: '🧭',
  category: 'Диагностика',
  title: 'Какой ты владелец?',
  description: '10 вопросов — врач, операционист или стратег. Узнайте на каком этапе вы как руководитель и что делать дальше.',
  link: 'https://claude.ai/public/artifacts/b21c5e32-ef91-421d-a557-b1768a5da1ae'
}, {
  id: 10,
  icon: '👤',
  category: 'Диагностика',
  title: 'Аудит администратора',
  description: '15 вопросов по трём зонам: конверсия звонков, сервис, no-show. Оценка и готовая система мотивации на выходе.',
  link: 'https://claude.ai/public/artifacts/47d6534b-d1f9-4da9-9840-ba61fd736d36'
}];
const categories = ['Все', 'Калькуляторы', 'Диагностика'];
export function ToolsPage({
  onNavigate
}: ToolsPageProps) {
  const [activeCategory, setActiveCategory] = useState('Все');
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const filtered = activeCategory === 'Все' ? tools : tools.filter(t => t.category === activeCategory);
  return <div className="min-h-screen bg-[#F4F6F9]" style={{
    fontFamily: "'Montserrat', sans-serif"
  }} data-id="element-778">
      {/* Google Fonts */}
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" data-id="element-779" />

      <DentosHeader currentPage="tools" onNavigate={onNavigate} data-id="element-780" />

      {/* HERO */}
      <section className="pt-32 pb-16 bg-[#0F1E3C] text-white" data-id="element-781">
        <div className="container mx-auto px-4 md:px-6" data-id="element-782">
          <span className="text-[#00C2D4] uppercase text-sm mb-4 block tracking-widest" style={{
          fontWeight: 600
        }} data-id="element-783">
            ИНСТРУМЕНТЫ
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight max-w-3xl" style={{
          fontWeight: 800
        }} data-id="element-784">
            Считайте прежде чем решать
          </h1>
          <p className="text-[#A0AEC0] text-lg md:text-xl max-w-2xl leading-relaxed" style={{
          fontWeight: 400
        }} data-id="element-785">
            10 бесплатных инструментов для владельцев стоматологий.
            <br className="hidden md:block" data-id="element-786" />
            Юнит-экономика, LTV, точка безубыточности, диагностика бизнеса.
          </p>
        </div>
      </section>

      {/* CATEGORY FILTER */}
      <div className="sticky top-[72px] z-40 bg-white border-b border-gray-200 shadow-sm py-4" data-id="element-787">
        <div className="container mx-auto px-4 md:px-6" data-id="element-788">
          <div className="flex space-x-3" data-id="element-789">
            {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className="px-6 py-2 rounded-full text-sm transition-all duration-300" style={{
            fontWeight: 600,
            fontFamily: "'Montserrat', sans-serif",
            background: activeCategory === cat ? '#00C2D4' : 'white',
            color: activeCategory === cat ? 'white' : '#4A5568',
            border: activeCategory === cat ? '1.5px solid #00C2D4' : '1.5px solid #E2E8F0',
            boxShadow: activeCategory === cat ? '0 2px 8px rgba(0,194,212,0.25)' : 'none'
          }} data-id="element-790">
                {cat}
              </button>)}
          </div>
        </div>
      </div>

      {/* TOOLS GRID */}
      <div className="container mx-auto px-4 md:px-6 py-14" data-id="element-791">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-792">
          {filtered.map(tool => <div key={tool.id} className="bg-white rounded-xl shadow-sm flex flex-col border-l-4 border-transparent hover:border-[#00C2D4] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group" data-id="element-793">
              <div className="p-7 flex flex-col h-full" data-id="element-794">
                {/* Icon */}
                <div className="text-4xl mb-5" data-id="element-795">{tool.icon}</div>

                {/* Category tag */}
                <span className="self-start bg-[#E6FAFB] text-[#00C2D4] text-xs px-3 py-1 rounded-full mb-4 uppercase tracking-wide" style={{
              fontWeight: 600
            }} data-id="element-796">
                  {tool.category}
                </span>

                {/* Title */}
                <h3 className="text-[#0F1E3C] text-lg mb-3 leading-snug" style={{
              fontWeight: 700
            }} data-id="element-797">
                  {tool.title}
                </h3>

                {/* Description */}
                <p className="text-[#718096] text-sm leading-relaxed mb-6 flex-grow" style={{
              fontWeight: 400
            }} data-id="element-798">
                  {tool.description}
                </p>

                {/* CTA */}
                <a href={tool.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-[#00C2D4] text-[#00C2D4] rounded-lg px-5 py-2.5 text-sm transition-all duration-200 hover:bg-[#00C2D4] hover:text-white self-start" style={{
              fontWeight: 600
            }} data-id="element-799">
                  Открыть инструмент
                  <ExternalLink size={14} data-id="element-800" />
                </a>
              </div>
            </div>)}
        </div>
      </div>

      {/* BOTTOM BANNER */}
      <section className="bg-[#0F1E3C] py-16 md:py-20" data-id="element-801">
        <div className="container mx-auto px-4 md:px-6" data-id="element-802">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-803">
            {/* Left */}
            <div className="lg:max-w-xl" data-id="element-804">
              <span className="text-[#00C2D4] text-sm uppercase tracking-widest mb-3 block" style={{
              fontWeight: 700
            }} data-id="element-805">
                DENTAL KIDS
              </span>
              <h2 className="text-white text-3xl md:text-4xl mb-4 leading-tight" style={{
              fontWeight: 800
            }} data-id="element-806">
                Первая клиника которая внедрит это — заберёт рынок
              </h2>
              <p className="text-[#A0AEC0] text-base mb-8 leading-relaxed" style={{
              fontWeight: 400
            }} data-id="element-807">
                Мобильное приложение для детских стоматологий
                <br data-id="element-808" />с геймификацией, онлайн-записью и телемедициной.
              </p>
              <a onClick={() => {
              onNavigate('dental-kids');
              window.scrollTo(0, 0);
            }} className="inline-flex items-center gap-2 bg-[#00C2D4] text-white px-7 py-3.5 rounded-lg transition-all duration-200 hover:bg-[#00a8b8] hover:gap-3" style={{
              fontWeight: 700
            }} data-id="element-809">
                Узнать подробнее
                <ArrowRight size={18} data-id="element-810" />
              </a>
            </div>

            {/* Right — Stats */}
            <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-8 lg:gap-10" data-id="element-811">
              {[{
              value: '730',
              label: 'визитов/год'
            }, {
              value: '5-7%',
              label: 'no-show'
            }, {
              value: '10',
              label: 'дней внедрение'
            }].map((stat, i) => <div key={i} className="text-center lg:text-left" data-id="element-812">
                  <div className="text-[#00C2D4] text-4xl md:text-5xl leading-none mb-1" style={{
                fontWeight: 800
              }} data-id="element-813">
                    {stat.value}
                  </div>
                  <div className="text-[#A0AEC0] text-sm uppercase tracking-wide" style={{
                fontWeight: 500
              }} data-id="element-814">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <DentosFooter onNavigate={onNavigate} data-id="element-815" />

      {showScrollTop && <button onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110" style={{
      background: '#00C2D4'
    }} aria-label="Наверх" data-id="element-816">
          <ArrowUp size={20} color="#fff" data-id="element-817" />
        </button>}
    </div>;
}